export class SyncExcecoesRejeicaoNFCeRequest {
  excecoes: SyncExcecaoRejeicaoNFCeItem[] = [];
}

export class SyncExcecaoRejeicaoNFCeItem {
  idExcecaoRejeicaoNFCe: number | null;
  codigoRejeicao: number;
  descricaoRejeicao: string;
}
